(function() {
  'use strict';

  const ENGRAVING_VARIANT_ID = 48583177273567;
  let engravingProcessed = false;

  // 🚫 Add product IDs here to disable auto-engraving for those products.
  // This is exposed as window.ENGRAVING_EXCLUDED_IDS so personalization-modal.js
  // (PDP) can also read the same list without duplication.
  window.ENGRAVING_EXCLUDED_IDS = window.ENGRAVING_EXCLUDED_IDS || [
    
  ];

  // Helper: checks all known personalization property keys, including the PDP 'Personalization' key
  function getEngravingText(properties) {
    if (!properties) return null;
    return properties['Custom Engraving']
      || properties['Engrave Name']
      || properties['Engraving Name']
      || properties['Personalization']
      || null;
  }
    
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEngraving);
    } else {
      setupEngraving();
    }
  }
  
  function setupEngraving() {
    interceptXHR();
    interceptFetch();
  }
  
  function interceptXHR() {
    const OriginalXHR = window.XMLHttpRequest;
    const originalOpen = OriginalXHR.prototype.open;
    const originalSend = OriginalXHR.prototype.send;
    
    OriginalXHR.prototype.open = function(method, url, ...rest) {
      this._url = url;
      this._method = method;
      return originalOpen.apply(this, [method, url, ...rest]);
    };
    
    OriginalXHR.prototype.send = function(body) {
      
      if (this._url && this._url.includes('/cart/add') && body) {
        
        try {
          let data = null;
          
          if (typeof body === 'string') {
            try {
              data = JSON.parse(body);
            } catch (e) {
              console.warn('Engraving XHR: Could not parse body as JSON', e);
            }
          }
          
          if (data && data.properties) {
            
            const engraveName = getEngravingText(data.properties);
            
            if (engraveName && engraveName.trim() && !engravingProcessed) {
              engravingProcessed = true;
              
              this.addEventListener('load', async function() {
                try {
                  if (this.status === 200) {
                    const mainProductData = JSON.parse(this.responseText);

                    // Skip engraving if product is in the excluded list
                    const excludedIds = window.ENGRAVING_EXCLUDED_IDS || [];
                    if (excludedIds.length > 0 && excludedIds.includes(mainProductData.product_id)) {
                      return;
                    }
                  
                    const engraveResponse = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({
                        id: ENGRAVING_VARIANT_ID,
                        quantity: data.quantity || 1,
                        properties: {
                          '_for_product': mainProductData.product_title || 'Product',
                          'engraved_name': engraveName.trim(),
                          '_main_product_engraving': 'true'
                        }
                      })
                    });
                    
                    if (engraveResponse.ok) {
                      await engraveResponse.json();
                      document.dispatchEvent(new CustomEvent('cart:updated'));
                    } else {
                      const errorData = await engraveResponse.json();
                      console.error('Failed to add engraving:', errorData);
                    }
                  }
                } catch (error) {
                  console.error('Error in XHR engraving handler:', error);
                } finally {
                  setTimeout(() => { engravingProcessed = false; }, 2000);
                }
              });
            }
          }
        } catch (e) {
          console.error('Engraving XHR interceptor error:', e);
        }
      }
      
      return originalSend.apply(this, [body]);
    };
    
  }
  
  function interceptFetch() {
    const originalFetch = window.fetch;
    
    window.fetch = async function(...args) {
      const [url, options] = args;
            
      if (url && url.includes('/cart/add') && options && options.body) {
        
        try {
          let data = null;
          
          if (typeof options.body === 'string') {
            try {
              data = JSON.parse(options.body);
            } catch (e) {
              console.warn('Engraving Fetch: Could not parse body as JSON', e);
            }
          } else if (options.body instanceof FormData) {
            data = {};
            data.properties = {};
            for (let [key, value] of options.body.entries()) {
              if (key.startsWith('properties[')) {
                const propName = key.match(/properties\[(.*?)\]/)[1];
                data.properties[propName] = value;
              } else if (key === 'id') {
                data.id = value;
              } else if (key === 'quantity') {
                data.quantity = parseInt(value, 10) || 1;
              }
            }
          }
          
          if (data && data.properties) {
            
            const engraveName = getEngravingText(data.properties);
            
            if (engraveName && engraveName.trim() && !engravingProcessed) {
              engravingProcessed = true;
              
              const response = await originalFetch.apply(this, args);
              const clonedResponse = response.clone();
              
              if (response.ok) {
                try {
                  const mainProductData = await clonedResponse.json();

                  // Skip engraving if product is in the excluded list
                  const excludedIds = window.ENGRAVING_EXCLUDED_IDS || [];
                  if (excludedIds.length > 0 && excludedIds.includes(mainProductData.product_id)) {
                    setTimeout(() => { engravingProcessed = false; }, 2000);
                    return response;
                  }
                  
                  const engraveResponse = await originalFetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      id: ENGRAVING_VARIANT_ID,
                      quantity: data.quantity || 1,
                      properties: {
                        '_for_product': mainProductData.product_title || 'Product',
                        'engraved_name': engraveName.trim(),
                        '_main_product_engraving': 'true'
                      }
                    })
                  });
                  
                  if (engraveResponse.ok) {
                    await engraveResponse.json();
                    document.dispatchEvent(new CustomEvent('cart:updated'));
                  } else {
                    const errorData = await engraveResponse.json();
                    console.error('Failed to add engraving via fetch:', errorData);
                  }
                } catch (error) {
                  console.error('Error in fetch engraving handler:', error);
                } finally {
                  setTimeout(() => { engravingProcessed = false; }, 2000);
                }
              } else {
                // Request failed — always reset the flag
                setTimeout(() => { engravingProcessed = false; }, 2000);
              }
              
              return response;
            }
          }
        } catch (e) {
          console.error('Engraving fetch interceptor error:', e);
        }
      }
      
      return originalFetch.apply(this, args);
    };
    
  }
  
  init();
})();

(function() {
  'use strict';

  const ENGRAVING_VARIANT_ID = 48583177273567;
  let isProcessing = false;

  // Helper: checks all known personalization property keys, including the PDP 'Personalization' key
  function getEngravingText(properties) {
    if (!properties) return null;
    return properties['Custom Engraving']
      || properties['Engrave Name']
      || properties['Engraving Name']
      || properties['Personalization']
      || null;
  }

  async function syncCart() {
    if (isProcessing) {
      return;
    }

    try {
      isProcessing = true;
      
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const itemsToRemove = [];
      const engravingItems = [];
      const mainProducts = [];

      cart.items.forEach(item => {
        if (item.variant_id === ENGRAVING_VARIANT_ID) {
          if (item.properties && item.properties['_main_product_engraving'] === 'true') {
            engravingItems.push(item);
          }
        } else if (item.properties && getEngravingText(item.properties)) {
          if (!item.properties['_byob']) {
            mainProducts.push(item);
          }
        }
      });


      // If an engraving item's linked product is no longer in the cart, remove the engraving item
      engravingItems.forEach(engraveItem => {
        const linkedProductTitle = engraveItem.properties['_for_product'];
        const hasMainProduct = mainProducts.some(p => p.product_title === linkedProductTitle);
        
        if (!hasMainProduct) {
          itemsToRemove.push(engraveItem.key);
        }
      });

      // If a main product with personalization has no matching engraving item, remove the main product
      mainProducts.forEach(mainItem => {
        const engravingText = getEngravingText(mainItem.properties);
        
        if (engravingText && engravingText.trim()) {
          const hasEngraving = engravingItems.some(e => 
            e.properties['_for_product'] === mainItem.product_title
          );
          
          if (!hasEngraving) {
            itemsToRemove.push(mainItem.key);
          }
        }
      });

      if (itemsToRemove.length > 0) {
        
        for (const itemKey of itemsToRemove) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: itemKey,
              quantity: 0
            })
          });
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        if (window.location.pathname.includes('/cart')) {
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      }

    } catch (error) {
      console.error('Sync: Error:', error);
    } finally {
      isProcessing = false;
    }
  }

  function setupCartMonitoring() {
    
    let previousCartItems = [];
    
    setInterval(async () => {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        const currentCartItems = cart.items.map(i => i.key);
        
        if (previousCartItems.length === 0) {
          previousCartItems = currentCartItems;
          return;
        }
        
        const itemsRemoved = previousCartItems.filter(key => !currentCartItems.includes(key));
        
        if (itemsRemoved.length > 0) {
          await syncCart();
        }
        
        previousCartItems = currentCartItems;
        
      } catch (error) {
        console.error('Sync: Monitor error:', error);
      }
    }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupCartMonitoring);
  } else {
    setupCartMonitoring();
  }

})();
